import * as React from "react";
import * as qs from "querystring";
import { Auth } from "client/stores";

/**
 * Notifies the user that their account has been logged out, and that they must log in again before their request can be made. Returns true if they accept the prompt to log in again, false if not.
 */
export function useUnauthorizedPrompt() {
    const prompt = React.useCallback((redirectBackTo?: string, queryString?: Object) => {
        const promptMessage =
            "Your account has been logged out, and you must log in again before your request can be made. Do you want to log in again?";

        if (confirm(promptMessage)) {
            window.location.search = qs.stringify({ redirect: redirectBackTo, qs: queryString });

            Auth.logout();

            return true;
        }

        return false;
    }, []);

    return prompt;
}
